<template>
  <b-overlay :show="loading">
    <button
      :disabled="disabled"
      @click="$emit('click')"
      class="button-primary button-save-modal ml-2 mr-2 pl-3 pr-3"
      :class="clase"
      type="button"
    >
      <span class="cta">
        <slot></slot>
      </span>
    </button>
    <template #overlay>
      <overlay-button></overlay-button>
    </template>
  </b-overlay>
</template>
<script>
import overlayButton from "../overlay/overlay-button.vue";

export default {
  components: { overlayButton },
  name: "save-modal",
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    clase: {
      default: "",
      type: String,
    },
  },
  emits: ["click"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">


.button-primary.disabled,
.button-primary:disabled {
  color: #b0bec5 !important;
  background: #eceff1 !important;
  border: none !important;
  span {
    color: #b0bec5 !important;
  }
}
</style>